import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { getSummaryForBoard, getSummaryForTeam, summaryForBoard, summaryForTeam } from "../api/pageApi";

export const usePageSummary = () => {
    const queryClient = useQueryClient();

    // Fetch page summary
    const { data: boardSummary, error: boardError, isLoading: boardLoading } = useQuery({
        queryKey: ["boardSummary"],
        queryFn: getSummaryForBoard,
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to fetch board summary ��");
        }
    });

    const { data: teamSummary, error: teamError, isLoading: teamLoading } = useQuery({
        queryKey: ["teamSummary"],
        queryFn: getSummaryForTeam,
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to fetch team summary ��");
        }
    })

    // Update page summary
    const updateBoardSummary = useMutation({
        mutationFn: summaryForBoard,
        onSuccess: (data) => {
            toast.success(data.message || "Updated summary");
            queryClient.setQueryData(["boardSummary"], data);
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to update board summary ��");
        }
    });

    const updateTeamSummary = useMutation({
        mutationFn: summaryForTeam,
        onSuccess: (data) => {
            toast.success("Team summary updated successfully.");
            queryClient.setQueryData(["teamSummary"], data);
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to update team summary ��");
        }
    })

    return {
        boardSummary, boardError, boardLoading,
        teamSummary, teamError, teamLoading,
        updateBoardPage:updateBoardSummary.mutate,
        updateTeamPage:updateTeamSummary.mutate,
        updateBoardPageloading:updateBoardSummary.isPending,
        updateBordPageSuccess:updateBoardSummary.isSuccess,
        updateTeamPageSuccess:updateTeamSummary.isSuccess,
        updateTeamPageLoading: updateTeamSummary.isPending,
    };
}